"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyValue = void 0;
const Shape_1 = require("lincd/lib/shapes/Shape");
const package_1 = require("../package");
const schema_1 = require("../ontologies/schema");
let PropertyValue = class PropertyValue extends Shape_1.Shape {
};
exports.PropertyValue = PropertyValue;
PropertyValue.targetClass = schema_1.schema.PropertyValue;
exports.PropertyValue = PropertyValue = __decorate([
    package_1.linkedShape
], PropertyValue);
//# sourceMappingURL=PropertyValue.js.map